<!-- 어두운 overlay 영역, 생성되는 animation이 적용되면 안된다. 적용되면 깝빡거려서 보기 싫다. -->
<div class="overlay3"
     (click)="onClose()"></div>

<!-- 팝업창 (팝업창만 등장하는 애니메이션 적용) -->
<div class="popup-wrap"
     *ngIf="show" [@PitchInOut]>

  <div class="popup-head">
    <a class="popup-close-btn" (click)="onClose()"></a>
  </div>

  <div class="popup-body" *ngIf="exampleSJ">

    <div class="head-box">
      <!-- app-word-disp [word]="word"></app-word-disp -->
      <app-example-disp [exampleSJ]="exampleSJ"></app-example-disp>

      <!-- app-word-play-btn [word]="word"></app-word-play-btn -->
    </div>

    <ng-container *ngIf="exampleSJ.voiceExIdx !== null">
      <div class="wav-box">
        <app-wav-graph class="wave_box"
                       [data]="data1"
                       [recorder]="recorderConfig">
        </app-wav-graph>
      </div>

      <div class="txt-box">
        소리를 듣고 따라해 봅니다.<br />
        녹음이 끝나면, 곧장 마이크를 다시 눌러야 종료가 됩니다.
      </div>

      <div class="wav-box">
        <app-wav-graph class="wave_box"
                       [data]="data2"
                       [recorder]="userConfig">
        </app-wav-graph>
      </div>

      <div class="record-btn-box">

        <div class="row">
          <button type="button" class="record-btn {{recording ? 'on' : '' }}"
                  (click)="onClickRecord($event)"></button>

          <div class="help-btn-box">
             <button type="button"
                     class="help-btn"
                     (click)="OpenPitchHelp($event)">도움말</button>
          </div>

          <div class="reset-btn-box">
            <button type="button"
                    class="reset-btn"
                    (click)="OpenConfirmReset($event)">사용자 변경</button>
          </div>

        </div>
      </div>
    </ng-container>

  </div>

</div>
